import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NavigationArea.html?raw';
import on from 'dojo/on';
import NavigationTile from './NavigationTile';
import { HtmlHelpers, TranslationHelpers } from "../../../more/Helpers";
import NavigationRow from './NavigationRow';



class NavigationArea extends compose(_WidgetBaseSP) {
    templateString: any = template;
    tilesContainer: HTMLElement;
    heading: HTMLElement;
    private layout: Navigation.TilesLayout;
    private _heading: string = "";
    private _headingIcon: string = "";
    private tiles: Array<{ config: Navigation.TileData, widget: any }>;

    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.tiles = [];
    }

    startup(data?: any): void {
        super.startup.apply(this, arguments as any);
    }

    /**
     * @deprecated Use setup instead
     * @param config
     * @param overrideHeading
     * @param overrideAlignment
     */
    setConfig(config: Navigation.NavigationSet, overrideHeading?: string, overrideAlignment?: Navigation.TilesAlignment) {
        this.setup(config, overrideHeading, overrideAlignment);
    }
    setup(config: Navigation.NavigationSet, overrideHeading?: string, overrideAlignment?: Navigation.TilesAlignment) {

        if (config.widthValue) {
            this.setWidthBaseValue(config.widthValue);
        }
        this.setHeading(typeof overrideHeading == "string" ? overrideHeading : config.heading);
        this.setAlignment(typeof overrideAlignment == "string" ? overrideAlignment : config.alignment);
        this.drawTiles(config.tiles);
    }
    setWidthBaseValue(width: string) {
        if (width) {
            this.domNode.style.setProperty("--widthBase", width);
        } else {
            this.domNode.style.removeProperty("--widthBase");
        }
    }
    setLayout(layout: Navigation.TilesLayout) {
        this.layout = layout;

        this.UiModder.domClass.toggle(this.tilesContainer, "compact", this.layout == "compact");
        this.UiModder.domClass.toggle(this.tilesContainer, "rows", this.layout == "rows");


        // nochmal zeichnen falls schon was vorhanden ist:
        if (this.tiles) {
            let data: Array<Navigation.TileData> = [];

            for (let tile of this.tiles) {
                data.push(tile.config);
            }

            this.drawTiles(data);
        }

    }

    setAlignment(behaviour: Navigation.TilesAlignment) {
        if (!behaviour) return;

        this.UiModder.domClass.toggle(this.tilesContainer, "flex", behaviour == "flex");
        this.UiModder.domClass.toggle(this.tilesContainer, "left", behaviour == "left");
        this.UiModder.domClass.toggle(this.tilesContainer, "center", behaviour == "center");
        this.UiModder.domClass.toggle(this.tilesContainer, "right", behaviour == "right");
        
      
    }

    drawTiles(data: Array<Navigation.TileData>) {


        this.UiModder.domConstruct.empty(this.tilesContainer);


        this.tiles = [];

        this._delayEmitUpdatedTiles();

        if (!data || !data.length) {
            return;
        }

        for (var i = 0; i < data.length; i++) {
            let tileData = data[i];
            let tile = this.addTile(tileData);
        }
    }

    setHeadingIcon(iconClass: string) {
        this._headingIcon = iconClass;
        this.setHeading(this._heading);
    }
    getHeadingIcon(): string {
        return this._headingIcon;
    }
    setHeading(text: string) {
        if (text && TranslationHelpers.canTranslate(text)) text = TranslationHelpers.translate(text);
        this.UiModder.domAttr.set(this.heading, "innerHTML", text);
        this.UiModder.domClass.toggle(this.heading, "w3-hide", !text);

        if (this._headingIcon) {
            let icon = HtmlHelpers.createFontawesomeIcon(this._headingIcon, "right", this.heading, "first");
        }

        this._heading = text;
    }

    getHeading(): string {
        return this._heading;
    }

    /**
     * neue Kachel einfügen, die nach dem Erstellen aber noch animiert eingeblendet werden muss.
     */
    private _addTile(data: Navigation.TileData): MdsLax<InstanceType<typeof NavigationTile>> {
        let tile: MdsLax<InstanceType<typeof NavigationTile>> = null;

        if (this.layout == "rows" || this.layout == "compact") {
            let row = new NavigationRow;
            tile = row;
        } else {
            tile = new NavigationTile();
        }

        this.UiModder.domClass.add(tile.domNode, "animatedGrow half");

        this.UiModder.domConstruct.place(tile.domNode, this.tilesContainer);

        tile.startup(data);

        this.tiles.push({ config: data, widget: tile });

        on(tile, "click", lang.hitch(this, this._onClick_Tile));

        this._delayEmitUpdatedTiles();

        return tile;
    }

    addTile(data: Navigation.TileData): MdsLax<InstanceType<typeof NavigationTile>> {
        let tile = this._addTile(data);

        // dieser Aufruf kann von außerhalb kommen, daher muss die Einblendanimation gehandled werden:
        if (!this._animationQueueTimeouts) this._animationQueueTimeouts = [];
        this._animationQueueTimeouts.push(setTimeout(lang.hitch(this, this._fadeInNextTile, tile, this._animationQueueTimeouts.length)))

        return tile;        
    }

    private _animationQueueTimeouts: Array<any> = null;

    private _fadeInNextTile(tile: MdsLax<InstanceType<typeof NavigationTile>>, index: number) {

        setTimeout(lang.hitch(this, this.UiModder.domClass.add, tile.domNode, "full"), index * 50);
        setTimeout(lang.hitch(this, this.UiModder.domClass.remove, tile.domNode, "animatedGrow full half"), index * 50 + 2000);

        if (index + 1 == this._animationQueueTimeouts.length) {
            this._animationQueueTimeouts = [];
        }
    }

    private _onClick_Tile(data: Navigation.TileData) {

        this.UiModder.domClass.add(this.tilesContainer, "clicked");
        setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.tilesContainer, "clicked"), 1500);

        this.emit("navigate", data);
    }

    private _emitHandle: any = null;
    private _delayEmitUpdatedTiles() {
        if (this._emitHandle != null) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "tilesUpdated", this.tiles), 100);
    }

    getTiles(): Array<any> {
        return this.tiles;
    }

    private _getTilesError(error) {
        this.StandbyStop();
        alert(error.Message);
    }

    navigate(target) {
        let url: any = window.appRoot + target;
        window.location = url;
    }
}

export default mdsWidget(NavigationArea);